<template>
  <div class="unlock-login">
    <div v-if="!isPhone" class="login-container">
      <div class="login-form-container">
        <div style="width: 68%;">
          <div class="text-login color-main-linear-blue">
            LOGIN
          </div>
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="top">
            <div class="title-container">
              <h3 class="title">Sign In to your account</h3>
            </div>

            <el-form-item prop="email" label="Email" class="login-form-item">
              <el-input
                ref="email"
                v-model="loginForm.email"
                class="login-input"
                placeholder="Email"
                name="email"
                type="text"
                tabindex="1"
                auto-complete="on"
                size="default"
              />
            </el-form-item>

            <el-form-item prop="password" label="Password" class="login-form-item">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                class="login-input"
                :type="passwordType"
                placeholder="Password"
                name="password"
                tabindex="2"
                auto-complete="on"
                size="default"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
              <!--              <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>-->
            </el-form-item>

            <el-form-item v-if="show_mfa_flag" prop="verify_code">
              <el-input
                ref="verify_code"
                v-model="loginForm.verify_code"
                class="login-input"
                style="margin: 10px 0"
                placeholder="MFA Verification Code"
                oninput="value=value.replace(/[^\d]/g,'')"
              />
            </el-form-item>

            <!--          <el-form-item v-if="getGoogleVerify()" prop="otp" style="width: 306px" required>-->
            <!--            <google-login-verify-->
            <!--              v-model="loginForm.otp"-->
            <!--              :is-binding-mfa="isBindingMfa"-->
            <!--              @getValidateCode="getValidateCode"-->
            <!--            />-->
            <!--          </el-form-item>-->
            <el-form-item>
              <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>
            </el-form-item>
            <el-button class="bg-color-main-linear-blue" :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="handleLogin">Login</el-button>
          </el-form>

          <div>
            <img class="login-bottom-logo" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo.png') : require('@/assets/logo/ezpay_logo.svg')">
            <div class="text-all-right">©️ {{ new Date().getFullYear() }} {{ $store.getters.isAruxpay ? 'Aruxpay' : 'Ezpay' }} Information Solutions Corp, All Rights Reserved</div>
          </div>
        </div>
      </div>
      <div class="login-img">
        <img width="100%" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo_big.svg') : require('@/assets/logo/logo_big.svg')">
      </div>

    </div>
    <div v-if="isPhone" class="xs-login-container">
      <div class="xs-login-container-content">
        <div>
          <div class="text-login color-main-linear-blue">
            LOGIN
          </div>
          <div>
            <img class="login-img" width="60%" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo_big.svg') : require('@/assets/logo/logo_big.svg')">
          </div>
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="xs-login-form" auto-complete="on" label-position="top">
            <div class="title-container">
              <div class="title">Sign In to your account</div>
            </div>

            <el-form-item prop="email" label="Email" class="login-form-item">
              <el-input
                ref="email"
                v-model="loginForm.email"
                class="login-input"
                placeholder="Email"
                name="email"
                type="text"
                tabindex="1"
                auto-complete="on"
                size="default"
              />
            </el-form-item>

            <el-form-item prop="password" label="Password" class="login-form-item">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                class="login-input"
                :type="passwordType"
                placeholder="Password"
                name="password"
                tabindex="2"
                auto-complete="on"
                size="default"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
              <!--              <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>-->
            </el-form-item>

            <el-form-item v-if="show_mfa_flag" prop="verify_code">
              <el-input
                ref="verify_code"
                v-model="loginForm.verify_code"
                class="login-input"
                style="margin: 10px 0"
                placeholder="MFA Verification Code"
                oninput="value=value.replace(/[^\d]/g,'')"
              />
            </el-form-item>

            <!--          <el-form-item v-if="getGoogleVerify()" prop="otp" style="width: 306px" required>-->
            <!--            <google-login-verify-->
            <!--              v-model="loginForm.otp"-->
            <!--              :is-binding-mfa="isBindingMfa"-->
            <!--              @getValidateCode="getValidateCode"-->
            <!--            />-->
            <!--          </el-form-item>-->
            <el-form-item>
              <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>
            </el-form-item>
            <el-button class="bg-color-main-linear-blue" :loading="loading" type="info" size="default" style="width:100%;font-weight:600" @click.native.prevent="handleLogin">Login</el-button>
          </el-form>

          <div class="mt-48" style="text-align: center;">
            <img class="login-bottom-logo" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo.png') : require('@/assets/logo/ezpay_logo.svg')">
            <div class="text-all-right">©️ {{ new Date().getFullYear() }} {{ $store.getters.isAruxpay ? 'Aruxpay' : 'Ezpay' }} Information Solutions Corp, All Rights Reserved</div>
          </div>
        </div>
      </div>
    </div>

    <binding-mfa-modal
      ref="bindingMFAModal"
      :is-binding-mfa="is_binding_mfa"
      :qr_code_base64="qr_code_base64"
      :secret_key="secret_key"
      @verify-code-login="verifyCodeLogin"
    />
  </div>
</template>

<script>
import { sendDeviceVerifyCode, verifyDeviceEmailCode } from '@/api/user'
import { getDeviceHeader, getLocalStorageVal, removeLocalStorageVal, setLocalStorageKeyVal } from '@/utils/helper'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'

export default {
  name: 'Login',
  components: {
    BindingMfaModal: () => import('@/views/ezpay/login/components/Modal/BindingMFAModal')
    // GoogleLoginVerify: () => import('@/views/components/GoogleLoginVerify')
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length <= 0) {
        return callback(new Error('Please enter the user name'))
      }
      return callback()
    }
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('The password can not be less than 8 ~ 15 digits'))
      }
      if (value.length < 6 || value.length > 15) {
        return callback(new Error('The password can not be less than 8 ~ 15 digits'))
      }
      return callback()
    }
    const validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please finish Google Verify'))
      }
      return callback()
    }
    const validateEmailCode = (rule, value, callback) => {
      if (this.checkEmailCodeFlag && !value) {
        return callback(new Error('Please input Email Verification Code'))
      }
      return callback()
    }
    const validateVerifyCode = (rule, value, callback) => {
      if (this.checkEmailCodeFlag && !value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.length < 6 || value.length > 6) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    this.MFA_STATUS = {
      open: 1,
      close: 2
    }
    return {
      loginForm: {
        email: '',
        password: '',
        emailCode: '',
        verify_code: '',
        otp: ''
      },
      loginRules: {
        email: [
          // { type: 'email', message: 'Please input the correct email', required: false, trigger: ['blur', 'change'] }
        ],
        // password: [{ required: false, trigger: 'blur', validator: validatePassword }],
        otp: [{ required: true, trigger: 'blur', validator: validateCode }],
        emailCode: [{ validator: validateEmailCode, trigger: ['blur', 'change'] }],
        verify_code: [{ validator: validateVerifyCode, trigger: ['blur', 'change'] }]
      },
      loading: false,
      passwordType: 'password',
      show_mfa_flag: false,
      deviceSecond: 60,
      deviceSecondFlag: !!getLocalStorageVal('device_second'),
      checkEmailCodeFlag: false,
      redirect: undefined,
      is_binding_mfa: true,
      qr_code_base64: '',
      secret_key: '',
      isPhone: false
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.changePage()
  },
  mounted() {
    const storageSecond = getLocalStorageVal('device_second') ? getLocalStorageVal('device_second') : 60
    this.deviceSecond = storageSecond < 0 ? 60 : storageSecond
    this.deviceSecondFlag = storageSecond >= 0 && storageSecond < 60
    if (this.deviceSecond < 60) {
      this.secretInterval()
    }
    window.onresize = () => {
      this.changePage()
    }
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    changePage() {
      const screenWidth = document.documentElement.clientWidth
      if (screenWidth <= 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    getValidateCode(value) {
      this.loginForm.otp = value
    },
    handleLogin() {
      this.login()
      // if (this.loginForm.verify_code || (this.show_mfa_flag && !this.loginForm.verify_code)) {
      //   this.login()
      // } else {
      //   this.checkSameDevice()
      // }
    },
    checkSameDevice() {
      // if (this.validateLogin()) {
      //   const params = {
      //     email: cryptoJSAesEncrypt(this.loginForm.email),
      //     password: cryptoJSAesEncrypt(this.loginForm.password)
      //   }
      //   checkDevice(params).then(res => {
      //     if (res.code === 10000) {
      //       this.show_mfa_flag = res.data.is_diff
      //       this.is_binding_mfa = true
      //       if (res.data.is_binding_mfa) {
      //         this.is_binding_mfa = false
      //         this.qr_code_base64 = res.data.qr_code_base64
      //         this.secret_key = res.data.secret_key
      //         this.$refs.bindingMFAModal.changModalStatus(true)
      //       }
      //       if (!this.show_mfa_flag) {
      this.login()
      //       } else {
      //         this.checkEmailCodeFlag = true
      //       }
      //     }
      //   })
      // }
    },
    checkSameDeviceEmailCode() {
      this.checkEmailCodeFlag = true
      if (this.validateLogin()) {
        const params = {
          email: cryptoJSAesEncrypt(this.loginForm.email),
          auth_code: this.loginForm.emailCode
        }
        verifyDeviceEmailCode(params).then(res => {
          if (res.code === 10000) {
            if (res.data.status) {
              removeLocalStorageVal('device_second')
              this.login()
            } else {
              const remain_send_num = res.data.remain_verify_num
              this.$message.error('Verification code Error.And you can try ' + remain_send_num + ' more times ')
            }
          }
        })
      }
    },
    submitReSendCode() {
      this.deviceSecondFlag = true
      this.checkEmailCodeFlag = false
      if (this.validateLogin()) {
        this.secretInterval()
        const params = {
          email: cryptoJSAesEncrypt(this.loginForm.email)
        }
        sendDeviceVerifyCode(params).then(res => {
          if (res.code === 10000) {
            const remain_send_num = res.data.remain_send_num
            this.$message.success(`Successful! And you can send verification code for ${remain_send_num} times`)
          }
        })
      } else {
        this.deviceSecondFlag = false
      }
    },
    secretInterval() {
      const that = this
      const secretInterval = setInterval(function() {
        that.deviceSecondFlag = true
        that.deviceSecond--
        setLocalStorageKeyVal('device_second', that.deviceSecond)
        if (that.deviceSecond <= 0) {
          that.deviceSecondFlag = false
          that.deviceSecond = 60
          clearInterval(secretInterval)
        }
      }, 1000)
    },
    verifyCodeLogin(value) {
      this.loginForm.verify_code = value.verify_code
      this.loginForm.otp = value.google_code ? value.google_code : this.loginForm.otp
      this.login()
    },
    login() {
      if (this.validateLogin()) {
        this.loading = true
        const aesKey = this.$commonFn.generateRandomString()
        const aesIV = this.$commonFn.generateRandomString()
        const { email, password, otp, emailCode, verify_code, mch_counterparty } = this.loginForm

        const params = { username: email.trim(), password: password, otp: otp, auth_code: emailCode, verify_code: verify_code, timestamp: Date.now(), device: getDeviceHeader(), mch_counterparty, source: 2 }

        if (this.$store.getters.isEz || this.$store.getters.isAruxpay) {
          params.mch_counterparty = 'unlock'
        } else {
          params.mch_counterparty = 'paycools'
        }

        const paramsData = {}
        const aesKeyIv = JSON.stringify({ key: aesKey, iv: aesIV })
        paramsData.key = this.$commonFn.rsaEncrypt(aesKeyIv)
        paramsData.param = this.$commonFn.cryptoJSAesEncrypt(JSON.stringify(params), aesKey, aesIV)
        paramsData.sign = this.$commonFn.rsaSign(JSON.stringify(params))
        this.$store.dispatch('user/login', paramsData).then((data) => {
          if (!data.token) {
            if (data.mfa_enable === this.MFA_STATUS['open']) {
              this.is_binding_mfa = data.is_binding_mfa
              this.show_mfa_flag = data.show_mfa_flag
              if (!data.is_binding_mfa) {
                this.qr_code_base64 = data.qr_code_base64
                this.secret_key = data.secret_key
                this.$refs.bindingMFAModal.changModalStatus(true)
              }
            }
            return
          }

          this.$router.push({ path: this.redirect || '/' })
        }).finally(() => {
          this.loading = false
        })
      }
    },
    validateLogin() {
      let flag = false
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          flag = true
        }
      })
      return flag
    },
    getGoogleVerify() {
      return true
    }
  }
}
</script>
<style>
.unlock-login  input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset !important;
   -webkit-text-fill-color: #4B5567 !important;
}
.unlock-login .login-input .el-input__inner{
  height: 42px;
  border: 1px solid #D2D8E3;
  font-size: 16px;
  border-radius: 8px;
}
.unlock-login .login-form-item .el-form-item__label{
  font-size: 18px;
}
.unlock-login .xs-login-container .google-login-verify{
  /* width: 250px; */
  overflow-y: hidden;
  overflow-x: auto;
}

@media screen and (max-width: 1441px) {
  .unlock-login .login-form-item .el-form-item__label{
    font-size: 16px;
  }
  .unlock-login .login-input .el-input__inner{
    height: 38px;
    font-size: 13px;
  }
}
</style>

<style lang="scss" scoped>
.unlock-login{
  height: 100vh;
}
.login-container {
  height: 100vh;
  width: 100%;
  background: #EDF2F9;
  overflow: hidden;
  display: flex;
  .login-img{
    // padding-top: 60px;
    width: 45%;
    min-height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
     .login-img-content{
       width: 80%;
     }
  }
  .login-form-container{
    position: relative;
    height: 100vh;
    width: 55%;
    display: flex;
    justify-content:center;
    align-items: center;
    overflow: hidden;
    .forgot-password{
      text-align: right;
      color: rgba(54, 60, 74, 0.5);
      font-weight: 500;
      font-size: 16px;
      float: right;
      cursor: pointer;
    }
  }

  .login-form {
    padding: 24px;
    max-width: 550px;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0px 155px 43px 0px rgba(0, 0, 0, 0.00), 0px 99px 40px 0px rgba(0, 0, 0, 0.02), 0px 56px 33px 0px rgba(0, 0, 0, 0.06), 0px 25px 25px 0px rgba(0, 0, 0, 0.10), 0px 6px 14px 0px rgba(0, 0, 0, 0.12);
  }
  .show-pwd{
    position: absolute;
    right: 13px;
    top: 3px;
    cursor: pointer;
  }
  .title{
    color: #364250;
    font-size: 22px;
  }
  .text-login{
    font-size: 64px;
    font-weight: 600;
    margin-bottom: 96px;
  }
  .login-bottom-logo{
    margin-top: 96px;
    height: 32px;
  }
  .text-all-right{
    margin-top: 24px;
    color: #5E6E82;
    font-size: 12px;
  }
}

@media screen and (max-width: 1441px) {
  .login-container{
    .login-form-container{
      // align-items: flex-start;
    }
    .text-login{
      font-size: 32px;
      margin-bottom: 20px;
      margin-top: 10px;
    }
    .login-bottom-logo{
      margin-top: 25px;
      height: 32px;
    }
    .text-all-right{
      margin-top: 10px;
      color: #5E6E82;
      font-size: 12px;
    }
  }
}
@media screen and (max-height: 780px){
  .login-container{
    .text-login{
      margin-bottom: 35px;
    }
    .login-bottom-logo{
      margin-top: 41px;
    }
  }
}
</style>

<style lang="scss" scoped>

.xs-login-container {
  height: 100vh;
  // width: 100%;
  padding:  0 30px;
  background: #EDF2F9;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-img{
    position: absolute;
    top: 0;
    right: 0;
  }
  .login-form-container{
    position: relative;
    height: 100vh;
    width: 55%;
    display: flex;
    justify-content:center;
    align-items: center;
    overflow: hidden;
  }

  .xs-login-form {
    position: relative;
    z-index: 2;
    padding: 24px;
    max-width: 550px;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0px 155px 43px 0px rgba(0, 0, 0, 0.00), 0px 99px 40px 0px rgba(0, 0, 0, 0.02), 0px 56px 33px 0px rgba(0, 0, 0, 0.06), 0px 25px 25px 0px rgba(0, 0, 0, 0.10), 0px 6px 14px 0px rgba(0, 0, 0, 0.12)
  }
  .show-pwd{
    position: absolute;
    right: 13px;
    top: 3px;
    cursor: pointer;
  }
  .title{
    color: #364250;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 32px;
  }
  .text-login{
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 49px;
  }
  .login-bottom-logo{
    height: 32px;
  }
  .text-all-right{
    margin-top: 24px;
    color: #5E6E82;
    font-size: 12px;
  }
  .forgot-password{
    text-align: right;
    color: rgba(54, 60, 74, 0.5);
    font-weight: 500;
    font-size: 16px;
    float: right;
    cursor: pointer;
  }
}

</style>
